import { render, staticRenderFns } from "./PromoCard.vue?vue&type=template&id=3f57d19f&scoped=true&"
import script from "./PromoCard.vue?vue&type=script&lang=ts&"
export * from "./PromoCard.vue?vue&type=script&lang=ts&"
import style0 from "./PromoCard.vue?vue&type=style&index=0&id=3f57d19f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f57d19f",
  null
  
)

export default component.exports